module.exports = __webpack_public_path__ + "img/fruit3.6756ea36.jpg";